const PhoneCallIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="23"
      viewBox="0 0 24 23"
      stroke="#039855"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5494 5C15.5262 5.19057 16.4238 5.66826 17.1275 6.37194C17.8312 7.07561 18.3089 7.97326 18.4994 8.95M14.5494 1C16.5787 1.22544 18.471 2.13417 19.9157 3.57701C21.3603 5.01984 22.2715 6.91101 22.4994 8.94M21.4994 16.92V19.92C21.5006 20.1985 21.4435 20.4742 21.332 20.7293C21.2204 20.9845 21.0567 21.2136 20.8515 21.4019C20.6463 21.5901 20.404 21.7335 20.1402 21.8227C19.8764 21.9119 19.5968 21.9451 19.3194 21.92C16.2423 21.5856 13.2864 20.5341 10.6894 18.85C8.27327 17.3147 6.22478 15.2662 4.68945 12.85C2.99942 10.2412 1.94769 7.27099 1.61944 4.18C1.59446 3.90347 1.62732 3.62476 1.71595 3.36162C1.80457 3.09849 1.94702 2.85669 2.13421 2.65162C2.32141 2.44655 2.54925 2.28271 2.80324 2.17052C3.05722 2.05833 3.33179 2.00026 3.60945 2H6.60945C7.09475 1.99522 7.56524 2.16708 7.93321 2.48353C8.30118 2.79999 8.54152 3.23945 8.60944 3.72C8.73607 4.68007 8.97089 5.62273 9.30945 6.53C9.44399 6.88792 9.47311 7.27691 9.39335 7.65088C9.3136 8.02485 9.12831 8.36811 8.85944 8.64L7.58945 9.91C9.013 12.4135 11.0859 14.4864 13.5894 15.91L14.8594 14.64C15.1313 14.3711 15.4746 14.1858 15.8486 14.1061C16.2225 14.0263 16.6115 14.0555 16.9694 14.19C17.8767 14.5286 18.8194 14.7634 19.7794 14.89C20.2652 14.9585 20.7088 15.2032 21.026 15.5775C21.3431 15.9518 21.5116 16.4296 21.4994 16.92Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PhoneCallIcon
